module.exports = __webpack_public_path__ + "img/rectangle-table-4.bb107f1d.png";